<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<style lang="less">
body {
  font-family: "Roboto Mono", monospace;
}

:root {
  --p-toast-width: 25rem;
  --p-toast-border-radius: var(--p-content-border-radius);
  --p-toast-border-width: 1px;
  --p-toast-transition-duration: var(--p-transition-duration);
  --p-toast-icon-size: 1.125rem;
  --p-toast-content-padding: var(--p-overlay-popover-padding);
  --p-toast-content-gap: 0.5rem;
  --p-toast-text-gap: 0.5rem;
  --p-toast-summary-font-weight: 500;
  --p-toast-summary-font-size: 1rem;
  --p-toast-detail-font-weight: 500;
  --p-toast-detail-font-size: 0.875rem;
  --p-toast-close-button-width: 1.75rem;
  --p-toast-close-button-height: 1.75rem;
  --p-toast-close-button-border-radius: 50%;
  --p-toast-close-button-focus-ring-width: var(--p-focus-ring-width);
  --p-toast-close-button-focus-ring-style: var(--p-focus-ring-style);
  --p-toast-close-button-focus-ring-offset: var(--p-focus-ring-offset);
  --p-toast-close-icon-size: 1rem;
  --p-toast-blur: 1.5px;
  --p-toast-info-background:
    color-mix(in srgb, var(--p-blue-50), transparent 5%);
  --p-toast-info-border-color: var(--p-blue-200);
  --p-toast-info-color: var(--p-blue-600);
  --p-toast-info-detail-color: var(--p-surface-700);
  --p-toast-info-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-blue-500), transparent 96%);
  --p-toast-info-close-button-hover-background: var(--p-blue-100);
  --p-toast-info-close-button-focus-ring-color: var(--p-blue-600);
  --p-toast-info-close-button-focus-ring-shadow: none;
  --p-toast-success-background:
    color-mix(in srgb, var(--p-green-50), transparent 5%);
  --p-toast-success-border-color: var(--p-green-200);
  --p-toast-success-color: var(--p-green-600);
  --p-toast-success-detail-color: var(--p-surface-700);
  --p-toast-success-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-green-500), transparent 96%);
  --p-toast-success-close-button-hover-background: var(--p-green-100);
  --p-toast-success-close-button-focus-ring-color: var(--p-green-600);
  --p-toast-success-close-button-focus-ring-shadow: none;
  --p-toast-warn-background:
    color-mix(in srgb, var(--p-yellow-50), transparent 5%);
  --p-toast-warn-border-color: var(--p-yellow-200);
  --p-toast-warn-color: var(--p-yellow-600);
  --p-toast-warn-detail-color: var(--p-surface-700);
  --p-toast-warn-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-yellow-500), transparent 96%);
  --p-toast-warn-close-button-hover-background: var(--p-yellow-100);
  --p-toast-warn-close-button-focus-ring-color: var(--p-yellow-600);
  --p-toast-warn-close-button-focus-ring-shadow: none;
  --p-toast-error-background:
    color-mix(in srgb, var(--p-red-50), transparent 5%);
  --p-toast-error-border-color: var(--p-red-200);
  --p-toast-error-color: var(--p-red-600);
  --p-toast-error-detail-color: var(--p-surface-700);
  --p-toast-error-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-red-500), transparent 96%);
  --p-toast-error-close-button-hover-background: var(--p-red-100);
  --p-toast-error-close-button-focus-ring-color: var(--p-red-600);
  --p-toast-error-close-button-focus-ring-shadow: none;
  --p-toast-secondary-background: var(--p-surface-100);
  --p-toast-secondary-border-color: var(--p-surface-200);
  --p-toast-secondary-color: var(--p-surface-600);
  --p-toast-secondary-detail-color: var(--p-surface-700);
  --p-toast-secondary-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-surface-500), transparent 96%);
  --p-toast-secondary-close-button-hover-background: var(--p-surface-200);
  --p-toast-secondary-close-button-focus-ring-color: var(--p-surface-600);
  --p-toast-secondary-close-button-focus-ring-shadow: none;
  --p-toast-contrast-background: var(--p-surface-900);
  --p-toast-contrast-border-color: var(--p-surface-950);
  --p-toast-contrast-color: var(--p-surface-50);
  --p-toast-contrast-detail-color: var(--p-surface-0);
  --p-toast-contrast-shadow: 0px 4px 8px 0px color-mix(in srgb, var(--p-surface-950), transparent 96%);
  --p-toast-contrast-close-button-hover-background: var(--p-surface-800);
  --p-toast-contrast-close-button-focus-ring-color: var(--p-surface-50);
  --p-toast-contrast-close-button-focus-ring-shadow: none;
}

#app {
  font-family: "Roboto Mono", monospace;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}


:root {
  --border-color: #dfe0e1;
}

@keyframes shake {
  0% {
    transform: scale(1) rotateZ(0);
  }

  5% {
    transform: scale(1.1) rotateZ(0);
    color: black;
  }

  7.5% {
    transform: scale(1.1) rotateZ(-10deg);
    color: #11a859;
  }

  10% {
    transform: scale(1.1) rotateZ(10deg);
  }

  12.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  15% {
    transform: scale(1.1) rotateZ(10deg);
  }

  17.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  20% {
    transform: scale(1.1) rotateZ(10deg);
  }

  22.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  25% {
    transform: scale(1.1) rotateZ(10deg);
  }

  27.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  30% {
    transform: scale(1.1) rotateZ(10deg);
  }

  32.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  35% {
    transform: scale(1) rotateZ(10deg);
    color: #11a859;
  }

  40% {
    transform: rotateZ(0);
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}


@keyframes at1 {
  0% {
    transform: scale(1);
  }

  40% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  44% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at2 {
  0% {
    transform: scale(1);
  }

  42% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  46% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at3 {
  0% {
    transform: scale(1);
  }

  44% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  48% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at4 {
  0% {
    transform: scale(1);
  }

  46% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  50% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at5 {
  0% {
    transform: scale(1);
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  52% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at6 {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  54% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at7 {
  0% {
    transform: scale(1);
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  56% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  60% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at8 {
  0% {
    transform: scale(1);
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  58% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  62% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at9 {
  0% {
    transform: scale(1);
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  60% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  64% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes at10 {
  0% {
    transform: scale(1);
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  62% {
    transform: scale(2);
    font-weight: bold;
    color: #11a859;
  }

  66% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

#public-view {
  padding-top: 130px;

  .container-fluid {
    max-width: 1700px;
  }



  #header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;

    .header-middle {
      display: flex;
      background-color: #11a859;
      max-height: 150px;
      overflow: hidden;
      transition: max-height .5s, padding .5s;

      .col-12 {
        display: flex;
        padding: 0;
      }

      #nav-mobile-menu-control,
      #shopping-cart-control {
        width: 62px;
        height: 62px;
        line-height: 62px;
        text-align: center;
        color: white;
        font-size: 20px;
        position: relative;

        a {
          color: inherit;
        }

        .num {
          position: absolute;
          top: 14px;
          right: 8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: white;
          color: black;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
        }

        .show-menu,
        .hide-menu {
          position: absolute;
          top: 0;
          left: 0;
          width: 62px;
          height: 62px;
          line-height: 62px;
          text-align: center;
        }

        .show-menu {
          opacity: 1;
        }

        .hide-menu {
          opacity: 0;
        }
      }

      #nav-mobile-menu-control {
        .show-menu {
          transition: transform 1s, opacity 0.2s 0.6s;
        }

        .hide-menu {
          transition: transform 1s, opacity .4s .6s;
          font-size: 40px;
        }

        &.active {
          .show-menu {
            opacity: 0;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

          .hide-menu {
            opacity: 1;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

        }
      }

      #page-logo {
        line-height: 62px;
        flex: 1;
        text-align: left;

        img {
          height: 45px;
        }
      }

      #hotline {
        display: none;
      }

      #header-search-box {
        display: none;
      }

    }

    .header_bottom {
      height: 55px;
      width: 100%;
      border-top: 1px solid var(--border-color);
      border-bottom: 1px solid var(--border-color);
      display: none;

      #pc-menu-wrap {
        display: flex;
        width: 100%;
        padding: 15px 0;

        #pc-menu-control {
          width: 230px;
          margin-right: 20px;
          font-size: 15px;
          border-right: 1px solid #dfe0e1;
          padding-right: 25px;
          cursor: pointer;
          position: relative;
          padding-left: 50px;

          .icon {
            margin-right: 20px;
            font-size: 19px;
          }

          &.active {
            color: #11a859;

            span {
              font-weight: bold;
            }
          }
        }

        #pc-menu-control {

          .show-menu,
          .hide-menu {
            position: absolute;
            top: -19px;
            left: 0;
            width: 62px;
            height: 62px;
            line-height: 62px;
            text-align: center;
          }

          .show-menu {
            opacity: 1;
          }

          .hide-menu {
            opacity: 0;
          }
        }

        #pc-menu-control {
          .show-menu {
            transition: transform 1s, opacity 0.2s 0.6s;
          }

          .hide-menu {
            transition: transform 1s, opacity .4s .6s;
            font-size: 40px;
          }

          &.active {
            .show-menu {
              opacity: 0;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

            .hide-menu {
              opacity: 1;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

          }
        }

        #pc-sub-menu {
          flex: 1;
          display: flex;
          flex-direction: row;

          a {
            color: inherit;
            text-decoration: none;
          }

          .menu-item {
            padding: 0 15px;
            height: 25px;
            overflow: hidden;

            a.active {
              color: #11a859;

            }

            &.item-full {
              flex: 1;
              display: flex;
              justify-content: flex-end;
            }

            .btn.btn-add-to-cart {
              height: 25px;
              padding-top: 0;
              padding-bottom: 0;
              position: relative;

              a {
                color: inherit;
              }

              .num {
                position: absolute;
                top: 0;
                right: 0;
                background-color: #11a859;
                color: white;
                width: 16px;
                height: 16px;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                border-radius: 50%;
              }
            }

            &.menu-logo {
              transition: max-width .5s, padding .5s;
              max-width: 0;
              padding: 0;
              overflow: hidden;
              word-break: keep-all;

              img {
                height: 24px;
              }

              .fa-phone {
                animation: shake 4s infinite;
              }

              span {
                display: inline-block;
              }

              span.t1 {
                animation: at1 4s infinite;

              }

              span.t2 {
                animation: at2 4s infinite;
              }

              span.t3 {
                animation: at3 4s infinite;
              }

              span.t4 {
                animation: at4 4s infinite;
              }

              span.t5 {
                animation: at5 4s infinite;
              }

              span.t6 {
                animation: at6 4s infinite;
              }

              span.t7 {
                animation: at7 4s infinite;
              }

              span.t8 {
                animation: at8 4s infinite;
              }

              span.t9 {
                animation: at9 4s infinite;
              }

              span.t10 {
                animation: at10 4s infinite;
              }
            }
          }
        }

      }

    }

    .header-mobile-search {
      padding-top: 15px;
      background-color: white;
      padding-bottom: 15px;
      max-height: 100px;
      transition: max-height 0.5s, padding-top 0.5s, padding-bottom 0.5s;

      #header-mobile-search-box {
        flex: 1;
        display: flex;
        justify-content: center;
        padding-left: 15px;
        padding-right: 15px;

        input {
          flex: 1;
          max-width: 600px;
          height: 41px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          padding-left: 20px;
          border: none;
          outline: none;
          background-color: #f5f5f5;
        }

        button {
          width: 50px;
          height: 41px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          border: none;
          background-color: #f5f5f5;
        }
      }
    }

    &.scroll-header {
      .header-mobile-search {
        max-height: 0;
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  #mobile-menu {
    position: fixed;
    z-index: 10000;
    top: 48px;
    bottom: 0;
    width: 100%;
    max-width: 395px;
    left: -450px;
    background: url("./assets/images/gear_2.png") top left repeat-x;
    transition: left 1s, top 1s;
    background-position-x: 11.5px;
    padding-top: 10px;
    display: flex;

    &.active {
      left: 0;
    }

    a {
      text-decoration: none;
      color: inherit;
    }

    #mobile-menu-x {
      background-color: #dfe0e1;
      display: flex;
      width: 100%;
      height: 100%;
      padding-top: 10px;
    }

    #categories-mobile-menu-left {
      padding: 20px 0 0 0;
      width: 80px;
      height: 100%;
      overflow-y: auto;
      background-color: white;

      &::-webkit-scrollbar {
        width: 4px;
        /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        /* Màu của thanh cuộn */
        border-radius: 4px;
        /* Bo góc cho thanh cuộn */
      }

      .menu-lv-1 {
        .image {
          text-align: center;
          display: block;

          img {
            max-width: 40px;
            max-height: 40px;
          }
        }

        .name {
          font-size: 14px;
          text-align: center;
          display: block;
        }

        &.active {
          .name {
            font-weight: bold;
            color: #11a859;
          }
        }
      }
    }

    #categories-mobile-menu-right {
      width: calc(100% - 80px);

      #categories-mobile-menu-right-x {
        background-color: #dfe0e1;
        height: 100%;
        width: 100%;
        padding: 20px 0;
        position: relative;

      }

      .menu-lv-1 {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        display: none;
        padding-top: 30px;

        &.active {
          display: block;
        }

        .menu-lv-2-wrap-x {
          list-style: none;
          display: flex;
          height: 100%;
          flex-direction: column;


          h3 {
            width: 100%;

            a {
              color: inherit;
              text-decoration: none;
            }
          }

          .menu-lv-2-wrap {
            list-style: none;
            width: 100%;
            padding: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            overflow-y: auto;
            flex-direction: row;

            &::-webkit-scrollbar {
              width: 4px;
              /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
            }

            &::-webkit-scrollbar-thumb {
              background-color: rgba(0, 0, 0, 0.2);
              /* Màu của thanh cuộn */
              border-radius: 4px;
              /* Bo góc cho thanh cuộn */
            }

            .menu-lv-2 {
              width: 120px;
              margin: 15px;
              max-width: calc(50% - 30px);
              padding: 10px 0;
              border-radius: 5px;
              background-color: white;

              >a {
                display: flex;
                width: 100%;
                text-align: center;
                justify-content: center;
                color: inherit;
                text-decoration: none;
                font-size: 14px;

                img {
                  max-width: 100%;
                }

                &:nth-of-type(2) {
                  padding: 5px 5px 0 5px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  #public-view {
    padding-top: 153px;

    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

          .num {
            top: 5px;
          }

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: white;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
            border: none;
            outline: none;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border: none;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
        background-color: white;
      }

      .header-mobile-search {
        display: none;
      }

      &.scroll-header {
        .header-middle {
          max-height: 0;
          padding: 0;
        }

        .header_bottom {
          #pc-menu-wrap {
            #pc-sub-menu {

              .menu-item {
                &.menu-logo {
                  max-width: 180px;
                  padding: 0 15px;
                }
              }
            }

          }
        }
      }
    }

    #header.scroll-header+#mobile-menu {
      top: 47px;
    }

    #mobile-menu {
      top: 137px;
      left: -100vw;
      bottom: 0;
      width: 100vw;
      max-width: 100vw;
      background: url("./assets/images/gear_2.png") top left repeat-x;
      background-position-x: 4.5px;

      ul {
        margin-bottom: 0;
      }

      &.active {
        left: 0;
      }

      #categories-mobile-menu-left {
        width: 225px;

        .menu-lv-1 {
          .text-lv-1 {
            display: flex;

            .image {
              width: 40px;
              display: inline-block;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              padding: 5px;

              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;
              }
            }

            .name {
              flex: 1;
              padding-left: 10px;
              line-height: 30px;
              text-align: left;
              cursor: pointer;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              padding-right: 10px;
            }
          }

        }
      }

      #categories-mobile-menu-right {
        width: calc(100% - 225px);
      }
    }
  }
}


@media (min-width: 1700px) {
  #public-view {
    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: white;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
            border: none;
            outline: none;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            border: none;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
      }
    }

    #mobile-menu {
      padding-left: calc(50vw - 850px);
      width: calc(50vw + 850px);
      background: none;

      &.active {
        left: 0;
      }

      &::before {
        content: " ";
        position: absolute;
        top: 0;
        right: 0;
        left: calc(50vw - 850px);
        ;
        background: url("./assets/images/gear_2.png") top left repeat-x;
        background-position-x: 15.5px;
        height: 11px;
      }

      &::after {
        content: " ";
        position: absolute;
        background-color: #dfe0e1;
        top: 10px;
        left: 0;
        bottom: 0;
        width: calc(50vw - 850px);

      }

      #categories-mobile-menu-left {}

      #categories-mobile-menu-right {}
    }
  }

}


@keyframes shake-kobler {
  0% {
    transform: scale(1) rotateZ(0);
  }

  5% {
    transform: scale(1.1) rotateZ(0);
    color: black;
  }

  7.5% {
    transform: scale(1.1) rotateZ(-10deg);
    color: #ed1c25;
  }

  10% {
    transform: scale(1.1) rotateZ(10deg);
  }

  12.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  15% {
    transform: scale(1.1) rotateZ(10deg);
  }

  17.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  20% {
    transform: scale(1.1) rotateZ(10deg);
  }

  22.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  25% {
    transform: scale(1.1) rotateZ(10deg);
  }

  27.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  30% {
    transform: scale(1.1) rotateZ(10deg);
  }

  32.5% {
    transform: scale(1.1) rotateZ(-10deg);
  }

  35% {
    transform: scale(1) rotateZ(10deg);
    color: #ed1c25;
  }

  40% {
    transform: rotateZ(0);
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}


@keyframes kobler-at1 {
  0% {
    transform: scale(1);
  }

  40% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  44% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at2 {
  0% {
    transform: scale(1);
  }

  42% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  46% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at3 {
  0% {
    transform: scale(1);
  }

  44% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  48% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at4 {
  0% {
    transform: scale(1);
  }

  46% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  50% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at5 {
  0% {
    transform: scale(1);
  }

  48% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  52% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at6 {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  54% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at7 {
  0% {
    transform: scale(1);
  }

  52% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  56% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  60% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at8 {
  0% {
    transform: scale(1);
  }

  54% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  58% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  62% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at9 {
  0% {
    transform: scale(1);
  }

  56% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  60% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  64% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

@keyframes kobler-at10 {
  0% {
    transform: scale(1);
  }

  58% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  62% {
    transform: scale(2);
    font-weight: bold;
    color: #ed1c25;
  }

  66% {
    transform: scale(1);
    font-weight: normal;
    color: black;
  }

  100% {
    transform: rotateZ(0);
  }
}

#public-kobler-view {
  padding-top: 130px;

  .container-fluid {
    max-width: 1700px;
  }



  #header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10000;

    .header-middle {
      display: flex;
      background-color: white;
      max-height: 150px;
      overflow: hidden;
      transition: max-height .5s, padding .5s;

      .col-12 {
        display: flex;
        padding: 0;
      }

      #header-search-box {
        input {
          border: 1px solid #ccc;
          border-right: none;
        }

        button {
          border: 1px solid #ccc;
          border-left: none;

        }
      }

      #nav-mobile-menu-control,
      #shopping-cart-control {
        width: 62px;
        height: 62px;
        line-height: 62px;
        text-align: center;
        color: black;
        font-size: 20px;
        position: relative;

        a {
          color: inherit;
        }

        .num {
          position: absolute;
          top: 14px;
          right: 8px;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: white;
          color: black;
          font-size: 12px;
          line-height: 16px;
          text-align: center;
        }

        .show-menu,
        .hide-menu {
          position: absolute;
          top: 0;
          left: 0;
          width: 62px;
          height: 62px;
          line-height: 62px;
          text-align: center;
        }

        .show-menu {
          opacity: 1;
        }

        .hide-menu {
          opacity: 0;
        }
      }

      #nav-mobile-menu-control {
        .show-menu {
          transition: transform 1s, opacity 0.2s 0.6s;
        }

        .hide-menu {
          transition: transform 1s, opacity .4s .6s;
          font-size: 40px;
        }

        &.active {
          .show-menu {
            opacity: 0;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

          .hide-menu {
            opacity: 1;
            transform: rotateZ(-420deg);
            transition: 1s transform, 0.2s opacity;
          }

        }
      }

      #page-logo {
        line-height: 62px;
        flex: 1;
        text-align: left;

        img {
          height: 45px;
        }
      }

      #hotline {
        display: none;
      }

      #header-search-box {
        display: none;
      }

    }

    .header_bottom {
      height: 55px;
      width: 100%;
      border-top: 1px solid var(--border-color);
      border-bottom: 1px solid var(--border-color);
      display: none;

      #pc-menu-wrap {
        display: flex;
        width: 100%;
        padding: 15px 0;

        #pc-menu-control {
          width: 230px;
          margin-right: 20px;
          font-size: 15px;
          border-right: 1px solid #dfe0e1;
          padding-right: 25px;
          cursor: pointer;
          position: relative;
          padding-left: 50px;

          .icon {
            margin-right: 20px;
            font-size: 19px;
          }

          &.active {
            color: #ed1c25;

            span {
              font-weight: bold;
            }
          }
        }

        #pc-menu-control {

          .show-menu,
          .hide-menu {
            position: absolute;
            top: -19px;
            left: 0;
            width: 62px;
            height: 62px;
            line-height: 62px;
            text-align: center;
          }

          .show-menu {
            opacity: 1;
          }

          .hide-menu {
            opacity: 0;
          }
        }

        #pc-menu-control {
          .show-menu {
            transition: transform 1s, opacity 0.2s 0.6s;
          }

          .hide-menu {
            transition: transform 1s, opacity .4s .6s;
            font-size: 40px;
          }

          &.active {
            .show-menu {
              opacity: 0;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

            .hide-menu {
              opacity: 1;
              transform: rotateZ(-420deg);
              transition: 1s transform, 0.2s opacity;
            }

          }
        }

        #pc-sub-menu {
          flex: 1;
          display: flex;
          flex-direction: row;

          a {
            color: inherit;
            text-decoration: none;
          }

          .menu-item {
            padding: 0 15px;
            height: 25px;
            overflow: hidden;

            a.active {
              color: #ed1c25;

            }

            &.item-full {
              flex: 1;
              display: flex;
              justify-content: flex-end;
            }

            .btn.btn-add-to-cart {
              height: 25px;
              padding-top: 0;
              padding-bottom: 0;
              position: relative;

              a {
                color: inherit;
              }

              .num {
                position: absolute;
                top: 0;
                right: 0;
                background-color: #ed1c25;
                color: black;
                width: 16px;
                height: 16px;
                font-size: 12px;
                line-height: 16px;
                text-align: center;
                border-radius: 50%;
              }
            }

            &.menu-logo {
              transition: max-width .5s, padding .5s;
              max-width: 0;
              padding: 0;
              overflow: hidden;
              word-break: keep-all;

              img {
                height: 24px;
              }

              .fa-phone {
                animation: shake-kobler 4s infinite;
              }

              span {
                display: inline-block;
              }

              span.t1 {
                animation: kobler-at1 4s infinite;

              }

              span.t2 {
                animation: kobler-at2 4s infinite;
              }

              span.t3 {
                animation: kobler-at3 4s infinite;
              }

              span.t4 {
                animation: kobler-at4 4s infinite;
              }

              span.t5 {
                animation: kobler-at5 4s infinite;
              }

              span.t6 {
                animation: kobler-at6 4s infinite;
              }

              span.t7 {
                animation: kobler-at7 4s infinite;
              }

              span.t8 {
                animation: kobler-at8 4s infinite;
              }

              span.t9 {
                animation: kobler-at9 4s infinite;
              }

              span.t10 {
                animation: kobler-at10 4s infinite;
              }
            }
          }
        }

      }

    }

    .header-mobile-search {
      padding-top: 15px;
      background-color: white;
      padding-bottom: 15px;
      max-height: 100px;
      transition: max-height 0.5s, padding-top 0.5s, padding-bottom 0.5s;

      #header-mobile-search-box {
        flex: 1;
        display: flex;
        justify-content: center;
        padding-left: 15px;
        padding-right: 15px;

        input {
          flex: 1;
          max-width: 600px;
          height: 41px;
          border-top-left-radius: 4px;
          border-bottom-left-radius: 4px;
          padding-left: 20px;
          background-color: #f5f5f5;
        }

        button {
          width: 50px;
          height: 41px;
          border-top-right-radius: 4px;
          border-bottom-right-radius: 4px;
          background-color: #f5f5f5;
        }
      }
    }

    &.scroll-header {
      .header-mobile-search {
        max-height: 0;
        overflow: hidden;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
  }

  #mobile-menu {
    position: fixed;
    z-index: 10000;
    top: 48px;
    bottom: 0;
    width: 100%;
    max-width: 395px;
    left: -450px;
    background: url("./assets/images/gear_2.png") top left repeat-x;
    transition: left 1s, top 1s;
    background-position-x: 11.5px;
    padding-top: 10px;
    display: flex;

    a {
      text-decoration: none;
      color: inherit;
    }

    &.active {
      left: 0;
    }

    #mobile-menu-x {
      background-color: #dfe0e1;
      display: flex;
      width: 100%;
      height: 100%;
      padding-top: 10px;
    }

    #categories-mobile-menu-left {
      padding: 20px 0 0 0;
      width: 80px;
      height: 100%;
      overflow-y: auto;
      background-color: white;

      &::-webkit-scrollbar {
        width: 4px;
        /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
      }

      &::-webkit-scrollbar-thumb {
        background-color: rgba(0, 0, 0, 0.2);
        /* Màu của thanh cuộn */
        border-radius: 4px;
        /* Bo góc cho thanh cuộn */
      }

      .menu-lv-1 {
        .image {
          text-align: center;
          display: block;

          img {
            max-width: 40px;
            max-height: 40px;
          }
        }

        .name {
          font-size: 14px;
          text-align: center;
          display: block;
        }

        &.active {
          .name {
            font-weight: bold;
            color: #ed1c25;
          }
        }
      }
    }

    #categories-mobile-menu-right {
      width: calc(100% - 80px);

      #categories-mobile-menu-right-x {
        background-color: #dfe0e1;
        height: 100%;
        width: 100%;
        padding: 20px 0;
        position: relative;

      }

      .menu-lv-1 {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        display: none;
        padding-top: 30px;

        &.active {
          display: block;
        }

        .menu-lv-2-wrap-x {
          list-style: none;
          display: flex;
          height: 100%;
          flex-direction: column;


          h3 {
            width: 100%;

            a {
              color: inherit;
              text-decoration: none;
            }
          }

          .menu-lv-2-wrap {
            list-style: none;
            width: 100%;
            padding: 0;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            overflow-y: auto;
            flex-direction: row;

            &::-webkit-scrollbar {
              width: 4px;
              /* Điều chỉnh độ rộng, có thể thay đổi theo nhu cầu */
            }

            &::-webkit-scrollbar-thumb {
              background-color: rgba(0, 0, 0, 0.2);
              /* Màu của thanh cuộn */
              border-radius: 4px;
              /* Bo góc cho thanh cuộn */
            }

            .menu-lv-2 {
              width: 120px;
              margin: 15px;
              max-width: calc(50% - 30px);
              padding: 10px 0;
              border-radius: 5px;
              background-color: white;

              >a {
                display: flex;
                width: 100%;
                text-align: center;
                justify-content: center;
                color: inherit;
                text-decoration: none;
                font-size: 14px;

                img {
                  max-width: 100%;
                }

                &:nth-of-type(2) {
                  padding: 5px 5px 0 5px;
                }
              }
            }
          }
        }
      }
    }
  }
}

@media (min-width: 992px) {
  #public-kobler-view {
    padding-top: 153px;

    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

          .num {
            top: 5px;
          }

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: black;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
        background-color: white;
      }

      .header-mobile-search {
        display: none;
      }

      &.scroll-header {
        .header-middle {
          max-height: 0;
          padding: 0;
        }

        .header_bottom {
          #pc-menu-wrap {
            #pc-sub-menu {

              .menu-item {
                &.menu-logo {
                  max-width: 180px;
                  padding: 0 15px;
                }
              }
            }

          }
        }
      }
    }

    #header.scroll-header+#mobile-menu {
      top: 47px;
    }

    #mobile-menu {
      top: 137px;
      left: -100vw;
      bottom: 0;
      width: 100vw;
      max-width: 100vw;
      background: url("./assets/images/gear_2.png") top left repeat-x;
      background-position-x: 4.5px;

      ul {
        margin-bottom: 0;
      }

      &.active {
        left: 0;
      }

      #categories-mobile-menu-left {
        width: 225px;

        .menu-lv-1 {
          .text-lv-1 {
            display: flex;

            .image {
              width: 40px;
              display: inline-block;
              height: 40px;
              border-radius: 50%;
              overflow: hidden;
              padding: 5px;

              img {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                overflow: hidden;
                cursor: pointer;
              }
            }

            .name {
              flex: 1;
              padding-left: 10px;
              line-height: 30px;
              text-align: left;
              cursor: pointer;
              white-space: nowrap;
              text-overflow: ellipsis;
              overflow: hidden;
              padding-right: 10px;
            }
          }

        }
      }

      #categories-mobile-menu-right {
        width: calc(100% - 225px);
      }
    }
  }
}


@media (min-width: 1700px) {
  #public-kobler-view {
    #header {
      .header-middle {
        padding: 24px 0;

        .col-12 {
          padding: 0 15px;
        }

        #nav-mobile-menu-control {
          display: none;
        }

        #shopping-cart-control {
          height: 43px;
          line-height: 43px;
          margin-right: 20px;

        }

        #hotline {
          height: 43px;
          line-height: 43px;
          color: black;
          text-align: center;
          display: flex;

          a {
            color: inherit;
          }

          .icon {
            width: 43px;
            font-size: 30px;
          }

          .text-wrap {
            line-height: 22px;
            text-align: left;
            padding-left: 10px;
            padding-right: 10px;

            .text {
              width: 100%;
              display: block;
              font-size: 13px;
            }

            a {
              color: inherit;
              text-decoration: none;
              font-size: 16px;
            }
          }
        }

        #page-logo {
          height: 43px;
          line-height: 43px;
          flex: none;
        }

        #header-search-box {
          flex: 1;
          display: flex;
          justify-content: center;
          padding-left: 30px;
          padding-right: 30px;

          input {
            flex: 1;
            max-width: 600px;
            height: 41px;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            padding-left: 20px;
          }

          button {
            width: 50px;
            height: 41px;
            border-top-right-radius: 4px;
            border-bottom-right-radius: 4px;
            background-color: white;
          }
        }

      }

      .header_bottom {
        display: flex;
      }
    }

    #mobile-menu {
      padding-left: calc(50vw - 850px);
      width: calc(50vw + 850px);
      background: none;

      &.active {
        left: 0;
      }

      &::before {
        content: " ";
        position: absolute;
        top: 0;
        right: 0;
        left: calc(50vw - 850px);
        ;
        background: url("./assets/images/gear_2.png") top left repeat-x;
        background-position-x: 15.5px;
        height: 11px;
      }

      &::after {
        content: " ";
        position: absolute;
        background-color: #dfe0e1;
        top: 10px;
        left: 0;
        bottom: 0;
        width: calc(50vw - 850px);

      }
    }
  }

}


.faq-area {
  padding-top: 40px;
  padding-bottom: 120px;

  .accordion {
    .accordion-item {
      .accordion-header {
        .accordion-button {
          position: relative;
          padding: 16px 20px 16px 50px;

          span:first-child {
            position: absolute;
            left: 20px;
            top: 50%;
            transform: translateY(-50%);
            font-size: 20px;
            color: #000;
          }
        }
      }

    }

  }
}



.blog-wrapper {
  .splide__track {
    .splide__list {
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      gap: 1px;
      padding: 1px;

      >.blog-item {
        width: 49%;
        outline: 1px solid #ccc;
        padding: 10px 10px 10px 10px;
        position: relative;

        .blog-item-img {
          padding-top: 100%;
          position: relative;

          a {
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            display: flex;
            justify-content: center;
            flex-direction: column;

            img {
              max-width: 100%;
              max-height: 100%;
            }

          }

        }

        .blog-item-info {
          padding-top: 10px;

          a {
            color: inherit;
            text-decoration: none;
          }

          ul {
            list-style: none;
            margin: 0;
            padding: 0;
          }

          .blog-title {}
        }
      }
    }
  }
}


@media (min-width: 500px) {
  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(50% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }

          .product-block {
            .content {
              .description {
                .price {
                  font-size: 16px;
                }

              }

            }
          }
        }
      }
    }
  }
}

@media (min-width: 600px) {

  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(33.3% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }
        }
      }
    }
  }

}


@media (min-width: 768px) {
  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(25% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }
        }
      }
    }
  }
}


@media (min-width: 992px) {
  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(20% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }
        }
      }
    }
  }
}

@media (min-width: 1200px) {
  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(16.6% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }
        }
      }
    }
  }

}


@media (min-width: 1400px) {
  .blog-wrapper {
    .splide__track {
      .splide__list {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        >.blog-item {
          width: calc(14.28% - 2px);
          padding: 10px 10px 10px 10px;

          .blog-item__row {
            width: 100%;
          }
        }
      }
    }
  }


}



.breadcrumb {
  border: 0;
  background-color: transparent;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  background-color: #f5f5f5;
  padding: 25px 20px;
  display: flex;
  justify-content: flex-start;
  width: 100%;
  margin: 0 0 60px 0;

  >li.breadcrumb-item {
    padding: 0 10px 0 0;
    white-space: inherit;
    word-break: break-word;
    font-size: 14px;
    text-shadow: 0 1px 0 #FFF;

    a {
      color: inherit;
      text-decoration: none;
      ;
    }
  }
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 10px;
  line-height: 24px;
  ;
}

#danh-muc-blog-page {
  aside {
    border: 1px solid #f5f5f5;
    padding: 10px;
    text-align: left;
    margin-bottom: 20px;

    a {
      color: inherit;
      text-decoration: none
    }

    ;

    ul {
      list-style: none;
      padding: 10px 0 0 0;
      display: flex;
      flex-wrap: wrap;

      li {
        a {
          padding: 5px 10px;
          font-size: 14px;
          line-height: 24px;
        }

        &:hover {
          a {
            color: #11a859;
          }
        }
      }

    }

    h2.sidebar-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 10px;
      padding: 8px 16px;
      background-color: #eeefef;

    }
  }
}
</style>
